(() => {
  const init = () => {
    if (!document.body.classList.contains('template-collection')) return;
    const grid = document.querySelector('.product-grid-container, #ProductGridContainer');
    if (grid && !grid.id) grid.id = 'MuseumExhibits';
    else if (grid) grid.id = 'MuseumExhibits';

    document.querySelectorAll('.quick-add__submit').forEach((button) => {
      const textNode = [...button.childNodes].find((n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
      if (textNode) textNode.textContent = ' Acquire This Piece ';
      else {
        const span = button.querySelector('span');
        if (span) span.textContent = 'Acquire This Piece';
      }
      button.setAttribute('aria-label', `Acquire ${button.closest('.card-wrapper')?.querySelector('.card__heading')?.textContent.trim() || 'this piece'}`);
    });

    document.querySelectorAll('.card__heading a').forEach((link) => {
      link.setAttribute('title', `View exhibit: ${link.textContent.trim()}`);
    });
  };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
